export const NO_TOKEN_URL= [
    "login",
    "register"
]

export const LOGIN_URL = "https://stageretailindia.blaccdot.ca/login"
// export const LOGIN_URL = "business.blaccdot.co.uk/login"
//export const LOGIN_URL = "http://115.97.58.168:3000/login"

// export const LOGIN_URL = "https://stageretailindia.blaccdot.ca/login";


// export const LOGIN_URL = "https://stageapilead.blaccdot.com/ldsstage/auth/login"
